"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "vertemate-con-minoprio": {
    "7c59e95f": [{
      "hkey": "20e5d464",
      "slug": "vertemate-con-minoprio",
      "name": "Vertemate con Minoprio",
      "primary": true,
      "skipSearch": false
    }],
    "minoprio": [{
      "hkey": "20e5d464",
      "slug": "vertemate-con-minoprio",
      "name": "Vertemate con Minoprio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0e2c14c": [{
      "hkey": "20e5d464",
      "slug": "vertemate-con-minoprio",
      "name": "Vertemate con Minoprio",
      "primary": true,
      "skipSearch": false
    }],
    "vertemate": [{
      "hkey": "20e5d464",
      "slug": "vertemate-con-minoprio",
      "name": "Vertemate con Minoprio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;